var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.93166L0.723405 3.20825L6.5 8.98485L12.2766 3.20825L13 3.93166L6.5 10.4317L0 3.93166Z",
    fill: "#1B80C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectDownIcon);
export default __webpack_public_path__ + "static/media/select-down-icon.4ef682d27a43f31718e2a8f70ff0a618.svg";
export { ForwardRef as ReactComponent };